export interface SubmitWaitlistParams {
  email: string;
  locale: string;
  source?: string;
  honeypot?: string;
}

export interface SubmitWaitlistResult {
  success: boolean;
  status?: 'created' | 'already_subscribed';
  message?: string;
  error?: string;
}

export async function submitWaitlist(
  params: SubmitWaitlistParams
): Promise<SubmitWaitlistResult> {
  try {
    const response = await fetch('/api/waitlist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    const data = (await response.json().catch(() => ({}))) as {
      error?: string;
      status?: 'created' | 'already_subscribed';
      message?: string;
    };

    if (!response.ok) {
      return {
        success: false,
        error: data.error || 'Failed to submit email. Please try again.',
      };
    }

    return {
      success: true,
      status: data.status || 'created',
      message: data.message,
    };
  } catch (err) {
    console.error('Waitlist submission fetch error:', err);
    // Graceful fallback for preview/standalone static dev without functions server
    return {
      success: true,
      status: 'created',
      message: 'Subscribed successfully (Local Demo Mode)',
    };
  }
}
